import React, {useEffect, useRef, useState} from 'react';
import {UsePermissions} from "../../../hooks/usePermissions";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {getData} from "../../../api/deduccion.service";
import {Dropdown} from "primereact/dropdown";
import {convertirModena, exportExcel} from "../../../shared/utils/utils";
import {Toast} from "primereact/toast";
import {ContainerTitleTable} from "../../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../../components/Containers/ContainerTable";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";

export const TableDeduccion = ({obtenerParametrosUser, nuevoUsuario, reload}) => {
    const [permisos] = UsePermissions()
    // parametros de la tabla
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [rowInit, setrowInit] = useState(50);
    const [deduccion, setDeduccion] = useState([]);

    const toast = useRef(null);

    // payload al backend

    const initParams = {
        first: 0,
        rows: 50,
        page: 1,
        sortField: null,
        sortOrder: null,
        filters: {
            'descripcion': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'descrip_abrev': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'orden': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'porcentaje': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'tipo': {operator: FilterOperator.OR, constraints: [{value: '', matchMode: FilterMatchMode.EQUALS}]},
            'estado': {operator: FilterOperator.OR, constraints: [{value: '', matchMode: FilterMatchMode.EQUALS}]},
        }
    };
    const [lazyParams, setLazyParams] = useState(initParams);

    async function init(datos) {
        const response = await getData(datos);
        const data = await response.data;
        return data.data;
    }

    const loadLazyData = () => {
        setLoading(true);
        init({lazyEvent: lazyParams}).then(data => {
            // record
            setTotalRecords(data.total);
            // total
            setDeduccion(data.record);
            setLoading(false);
        })
    }

    const onSort = (event) => {
        setLazyParams(event);
    }

    const onPage = (event) => {
        setrowInit(event.rows);
        setLazyParams(event);
    }

    const laziParamsInit = () => {
        setLazyParams(initParams);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }


    useEffect(() => {
        loadLazyData();
        return () => {
            // record
            setTotalRecords(0);
            // total
            setDeduccion([]);

        }
    }, [lazyParams])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (reload) {
            loadLazyData();
        }
        return () => {
            // record

            // setTotalRecords(0);
            // total
            // setDeduccion([]);
        }
    }, [reload]);

    const statuses = [
        {
            name: "Activo",
            value: "A"
        },
        {
            name: "Inactivo",
            value: "I"
        }
    ];

    const statusItemTemplate = (option) => {
        return <span className={`customer-badge status-${option.value}`}>{option.name}</span>;
    }

    const statusFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={statuses}
                         onChange={(e) => options.filterCallback(e.value, options.index)}
                         optionLabel="name"
                         itemTemplate={statusItemTemplate}
                         placeholder="Seleccione un estado" className="p-column-filter"
                         showClear/>;
    }

    const tipo = [
        {
            name: "Manual",
            value: "M"
        },
        {
            name: "Formulado",
            value: "F"
        }
    ];


    const TipoFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={tipo}
                         onChange={(e) => options.filterCallback(e.value, options.index)}
                         optionLabel="name"
                         itemTemplate={statusItemTemplate}
                         placeholder="Seleccione un estado" className="p-column-filter"
                         showClear/>;
    }
    const header = (
        <div className="flex align-items-center justify-between">
            <div>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.adicionar)}
                    onClick={nuevoUsuario}
                >
                    <i className="fa fa-user"/>
                </button>
            </div>
            <div>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.consultar)}
                    onClick={loadLazyData}
                >
                    <i className="fa fa-search"/>
                </button>

                <button
                    onClick={laziParamsInit}
                    disabled={(!permisos.consultar)}
                    className="secundary-color-btn btn"
                    type="button"
                >
                    <i className="fa fa-filter"/>
                </button>
                <button
                    onClick={() => exportExcel(deduccion, "deduccion")}
                    disabled={(!permisos.consultar)}
                    className="secundary-color-btn btn"
                    type="button"
                >
                    <i className="fa fa-print"/>
                </button>
            </div>

        </div>
    );

    const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">

                <button
                    disabled={(!permisos.editar)}
                    className="btn primary-color-btn"
                    type="button"
                    onClick={() => obtenerParametrosUser(rowData)}>
                    <i className="fa fa-user-edit"/>
                </button>
            </div>
        );
    }

    const valueBodyTemplate = (rowData) => {
        return convertirModena(rowData.valor);
    }

    return (
        <>
            <Toast ref={toast}/>
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>

            <ContainerTable>
                <DataTable
                    showGridlines
                    header={header}
                    resizableColumns
                    columnResizeMode="expand"

                    size="small"
                    value={deduccion}
                    lazy
                    filterDisplay="menu"
                    first={lazyParams.first}
                    totalRecords={totalRecords}
                    onPage={onPage}
                    onSort={onSort}
                    sortField={lazyParams.sortField}
                    sortOrder={lazyParams.sortOrder}
                    onFilter={onFilter}
                    filters={lazyParams.filters}
                    loading={loading}
                    scrollable scrollHeight="500px"
                    paginator
                    rows={rowInit}
                    rowsPerPageOptions={[50, 100, 300, 500]}

                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} deducciones"
                    responsiveLayout="scroll">
                    <Column header="Editar" style={{fontSize: ".8em"}} body={actionTemplate}></Column>
                    <Column field="descripcion" header="Descripción" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="descrip_abrev" header="Descripcion abreviada" sortable filter
                            showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="orden" header="Orden" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>

                    <Column field="tipo" header="Tipo" sortable filter
                            filterElement={TipoFilterTemplate} showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>

                    <Column field="porcentaje" header="Porcentaje" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>

                    <Column field="valor" body={valueBodyTemplate} header="Valor" sortable filter
                            showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}/>

                    <Column field="estado" header="Estado" sortable filter
                            filterElement={statusFilterTemplate} showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                </DataTable>
            </ContainerTable>
        </>
    );
};



